export default __webpack_public_path__ + "static/media/demo_screenshot.210edbcc.png";